module.exports = __webpack_public_path__ + "img/negative-icon.76d8307a.svg";